import { FormattedMessage } from 'react-intl';
import { useCallback } from 'react';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { emptyObject } from 'ui-components/default-props/empty';
import { NumberInput } from 'ui-components/components/number-input';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../messages';

const QuantityCell = ({ row, handleProductQuantityChange, isReadOnly }) => {
  const { productId, quantity } = row?.original || emptyObject;

  const onChange = useCallback(
    (newQuantity) => {
      handleProductQuantityChange({ productId, newQuantity });
    },
    [handleProductQuantityChange, productId],
  );

  if (isReadOnly) {
    return <Text textType={TextType.Paragraph} value={quantity} />;
  }

  return <NumberInput min={1} onChange={onChange} value={quantity} />;
};

export const createQuantityColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'quantity',
  Header: <FormattedMessage {...messages.quantityColumnHeader} />,
  Cell: QuantityCell,
  width: 1,
});
